import React from "react";
import InputForm from "../../generales/InputForm";
import { capitalizeFirstLetter } from "../../../utils/utils";
import Action from "../../Action";
import { useState ,useEffect} from 'react';
import Modal from "react-modal";
import ModalLinKHost from "../ModalLinKHost";
const hostListModalSyncStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    height: "90%",
    padding: "20px",
  },
};
const Step2 = ({hostSelected,setHostSelected,handleChange,cisData,changeOption,editActive,setCisData,server,handleShowPopup,languaje,mode,cisSelectedAux,setPoolRows2,services_catalog,groups_catalog,location_catalog}) => {
  const [hostsListSyncModalOpen, setHostsListSyncModalOpen] =useState(false);
  function openHostsListSyncModal() {
  //    setCisSelectedAux(elemento);
      setHostsListSyncModalOpen(true);
    }

  function closHostsListSyncModal() {
    
    setHostsListSyncModalOpen(false);
  }
  function vincular(){
    setCisData((prevState)=>{
      return {
          ...prevState,
            ['hostid']:hostSelected.hostid,
            ['ip']:hostSelected.agent_ip,
        ['affiliation']:hostSelected.alias,
        ['brand_id']:hostSelected.brand_id,
        ['location_id']:hostSelected.location_id,
        ['mac']:hostSelected.mac,
        ['model_id']:hostSelected.model_id,
        ['serial_no']:hostSelected.serialno,
        
      } 
      
  })
    closHostsListSyncModal()
  }
  function desvincular(){
    setHostSelected({hostid:0})

    setCisData((prevState)=>{
      return {
          ...prevState,
            ['hostid']:0,
            ['ip']:"",
        ['affiliation']:"",
        ['brand_id']:null,
        ['location_id']:null,
        ['mac']:"",
        ['model_id']:null,
        ['serial_no']:"",
        
      } 
      
  })
    closHostsListSyncModal()
  }
  return(
      <>
      <div className="cont-step-modal">
          <div className="compact-step-modal">
               <div className="title-step-modal">
              <div className="txt-title-step-modal">
                   {'DETALLE DEL CIS'}
              </div>               
          </div>
          <div className="body-step-modal">
              <div className={"compact-body-step-modal "}>
                <div className="row-form-modal">
                  <div className="colum-form-modal">
                      {(services_catalog.loading)?<div className='load-data-selector' >Cargando Datos. . .</div>:
                      <InputForm 
                      type='selector'
                      msgError={''}  
                      error={false} 
                      changeOption={changeOption}  
                      attr={'service_id'} 
                      titulo={'Servicio'} 
                      loading={services_catalog.loading} 
                      data={services_catalog.data.data} 
                      optionDefault={cisData.service_id==null?0:cisData.service_id} 
                      placeHolder={'Selecciona un Servicio'} 
                      disabled={false} 
                      isRequired={false}
                      endpoint={'services_catalog'}
                      />
                      }
                      </div>
                <div className="colum-form-modal">
                      {(groups_catalog.loading)?<div className='load-data-selector' >Cargando Datos. . .</div>: 
                      <InputForm 
                      type='selector'
                      msgError={''} 
                      error={false} 
                      changeOption={changeOption}  
                      attr={'ci_group_id'} 
                      titulo={'Grupo CI'} 
                      loading={groups_catalog.loading} 
                      data={groups_catalog.data.data
.filter(item => item.type === "SUBGRUPO")
.map(item => ({
  ...item,
  name: `${item.name} (${item.parent_name})`
}))} 
                      optionDefault={cisData.ci_group_id==null?0:cisData.ci_group_id} 
                      placeHolder={'Selecciona un grupo'} 
                      disabled={false} 
                      isRequired={true}
                      endpoint={'groups_catalog'}/>
                      }
                  </div>
                </div>
                
                <div className="row-form-modal">
                   <div className="colum-form-modal">
                      {(location_catalog.loading)?<div className='load-data-selector' >Cargando Datos. . .</div>: 
                      <InputForm 
                      type='selector'
                      msgError={''} 
                      error={false} 
                      changeOption={changeOption}  
                      attr={'location_id'} 
                      titulo={'Ubicación'} 
                      loading={location_catalog.loading} 
                      data={location_catalog.data.data} 
                      optionDefault={cisData.location_id==null?0:cisData.location_id} 
                      placeHolder={'Selecciona un Ubicación'} 
                      disabled={false} 
                      isRequired={true}
                      endpoint={'Municipio'}/>
                      }
                  </div>
                </div>
                 
                
              </div>
          </div>
      </div>
      </div>      
      <Modal
      isOpen={hostsListSyncModalOpen}
      // isOpen={true}
      // onAfterOpen={afterOpenExeption}
      onRequestClose={closHostsListSyncModal}
      style={hostListModalSyncStyles}
      contentLabel="Example Modal2"
      // shouldCloseOnOverlayClick={false}
      >
        <ModalLinKHost vincular={vincular} desvincular={desvincular} isData={cisData} hostSelected={hostSelected} setHostSelected={setHostSelected} editActive={editActive} setCisData={setCisData}  server={server} handleShowPopup={handleShowPopup}  cisSelectRow={cisSelectedAux} setPoolRows={setPoolRows2} languaje={languaje}  mode={mode} closeAddHostModal={closHostsListSyncModal}   ></ModalLinKHost>
  </Modal>
      </>
  )
}

export default Step2;
 